import { useDispatch, useSelector } from "react-redux";
import { TOAST_SEVERITY } from "static/constants";
import { useEffect } from "react";

import {
  useGetFormSettingsQuery,
  useGetPatientDataPointsQuery,
  useUpdatePatientDataPointMutation,
} from "app/store/patient/api/patientApi";
import { showToast } from "utils/toast";

import { toggleDataPointMode } from "app/store/transmission/slice/transmissionSlice";

const useDataPoints = (formChanged, setFormChanged) => {
  const dispatch = useDispatch();
  const { patientId, isDataPointUpdated } = useSelector(
    (state) => state.transmission
  );

  const { isLoading: isSchemaLoading, data: dataPointSchemaList = [] } =
    useGetFormSettingsQuery();

  const {
    isLoading: isDataPointLoading,
    data: datapoint = {},
    isFetching: isDataPointFetching,
  } = useGetPatientDataPointsQuery(patientId, {
    refetchOnMountOrArgChange: true,
  });

  const [updatePatientDataPoint] = useUpdatePatientDataPointMutation();

  useEffect(() => {
    if (datapoint && Object.keys(datapoint)?.length > 0) {
      dispatch(toggleDataPointMode(true));
    }

    return () => dispatch(toggleDataPointMode(false));
  }, [datapoint]);

  const updateDataPoint = async () => {
    try {
      const result = await updatePatientDataPoint({
        patientId,
        formData: formChanged,
        isUpdate: isDataPointUpdated,
      }).unwrap();

      if (result) {
        showToast({ message: "Data point updated successfully." });
        dispatch(toggleDataPointMode(true));
      }
    } catch (error) {
      showToast({
        type: TOAST_SEVERITY.ERROR,
        message: error?.message || "Something went wrong, please try again.",
      });
    }
  };

  const handleReset = (fieldName, setFieldValue, key) => {
    if (Object?.hasOwn(formChanged, fieldName)) {
      const formValues = { ...formChanged };

      delete formValues?.[fieldName];
      setFormChanged(formValues);

      if (Object?.hasOwn(formValues, key) === false) {
        setFieldValue(key, false);
      }
    }
  };

  return {
    isSchemaLoading,
    isDataPointLoading,
    isDataPointFetching,
    dataPointSchemaList,

    datapoint,
    handleReset,
    updateDataPoint,
  };
};
export default useDataPoints;
